<mat-form-field class="{{ vehicleTypeSelectOptions.class }}">
  <mat-label>{{ vehicleTypeSelectOptions.label | translate }}</mat-label>
  <input id="{{idPrefix}}vehicle.type.autocomplete"
         matInput type="text"
         [matAutocomplete]="vehicleTypeAC"
         [(ngModel)]="type"
         (ngModelChange)="updateVehicleTypeList($event)"
         (blur)="onBlurVehicleType()">
  <mat-autocomplete #vehicleTypeAC="matAutocomplete"
                    (opened)="vehicleTypeSelectIsOpen = true"
                    (closed)="vehicleTypeSelectIsOpen = false"
                    (optionSelected)="onBlurVehicleType(true)">
    <mat-option *ngFor="let item of filteredVehicleTypes; let idx = index"
                id="{{idPrefix}}vehicle.type.autocomplete.item_{{getIdForSelectList(item)}}"
                [value]="item">
      {{ item }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>

<mat-form-field class="{{ manufacturerSelectOptions.class }}">
  <mat-label>{{ manufacturerSelectOptions.label | translate }}</mat-label>
  <input id="{{idPrefix}}vehicle.manufacturer.autocomplete"
         matInput type="text"
         [matAutocomplete]="manufacturerAC"
         [(ngModel)]="manufacturer"
         (ngModelChange)="updateManufacturerList($event)"
         (blur)="onBlurManufacturer()">
  <mat-autocomplete #manufacturerAC="matAutocomplete"
                    (opened)="manufacturerSelectIsOpen = true"
                    (closed)="manufacturerSelectIsOpen = false"
                    (optionSelected)="onBlurManufacturer(true)">
    <mat-option *ngFor="let item of filteredManufacturers; let idx = index"
                id="{{idPrefix}}vehicle.manufacturer.autocomplete.item_{{getIdForSelectList(item)}}"
                [value]="item">
      {{ item }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
